import { Button, Group, Stack, Text } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useTranslation } from "react-i18next";

import { toLocalDateString } from "../../lib/date.js";

export interface Quartalsende {
  quarter: number;
  year: number;
  date: Date;
}

/**
 * Die nächsten `anzahl` Quartalsenden ab `heute`, das laufende Quartal
 * zuerst (#351: „bis Ende Q1“ statt eines erfundenen Tages). Lokale
 * Mitternacht wie beim Kalender, damit `toLocalDateString` den Tag hält.
 */
export function naechsteQuartalsenden(heute: Date, anzahl = 3): Quartalsende[] {
  const ersterMonat = Math.floor(heute.getMonth() / 3) * 3;
  return Array.from({ length: anzahl }, (_, i) => {
    // Tag 0 des Folgemonats = letzter Tag des Quartals.
    const date = new Date(heute.getFullYear(), ersterMonat + 3 * (i + 1), 0);
    return { quarter: Math.floor(date.getMonth() / 3) + 1, year: date.getFullYear(), date };
  });
}

/**
 * Frist für „in Klärung“: frei wählbares Datum, dazu Knöpfe für die
 * nächsten Quartalsenden. Vergangene Tage sind gesperrt.
 */
export function ClarifyDeadlineInput({
  value,
  onChange,
  error,
}: {
  value: Date | null;
  onChange: (value: Date | null) => void;
  error?: string;
}) {
  const { t } = useTranslation();
  const heute = new Date();
  const gewaehlt = value ? toLocalDateString(value) : null;

  return (
    <Stack gap={6}>
      <DatePickerInput
        label={t("pages.visits.clarify.deadline")}
        withAsterisk
        placeholder={t("pages.visits.clarify.deadlinePlaceholder")}
        value={value}
        onChange={onChange}
        error={error}
        minDate={heute}
        locale="de"
      />
      <Group gap="xs">
        <Text size="xs" c="dimmed">
          {t("pages.visits.clarify.quarterEndLabel")}
        </Text>
        {naechsteQuartalsenden(heute).map((q) => (
          <Button
            key={`${q.year}-${q.quarter}`}
            size="compact-xs"
            variant={gewaehlt === toLocalDateString(q.date) ? "filled" : "light"}
            onClick={() => onChange(q.date)}
          >
            {t("pages.visits.clarify.quarterEnd", { quarter: q.quarter, year: q.year })}
          </Button>
        ))}
      </Group>
    </Stack>
  );
}
